import { useHitMap } from '@/hooks/useHitMap'
import './SessionPop.css'

import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { useNavigate } from 'react-router-dom'
import { StaticPaginatedTable, StaticPaginatedTableState } from '@/components/search/StaticPaginatedTable'

import { User } from '@/services/repository/users'
import { Translates } from '@/services/repository/i18n'
import { SessionsResponse, SessionStat } from '@/pages/communal/statistics/components/common/data'
import { formatDate, getTodayRange, secondsToDHM } from '@/common/time'
import { TimeDHM } from '@/components/Elements/time'
import { UserDeviceHistoriesData, UserDeviceHistoriesMachine } from '@/pages/communal/statistics/requests/histories'
import { CommunalUserPathMap } from '@/pages/communal/statistics/userstatistic/components/Map/PathMap'

import {
  Chart as ChartJS,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  TimeScale,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";
import "chartjs-adapter-date-fns";
import { Line } from "react-chartjs-2";
import { HitMapNav, HitMapNavData, HitMapNavURLParams, hitsMap } from '@/pages/communal/HitMap'
import { HitMapComponent } from '@/components/Map/HitMap'
import { HitText } from '@/components/hit/HitText'
import { Machine } from '@/services/model/machine'
import { MachineHistoryChart } from '../components/bucketschart/MachineHistoryChart'

ChartJS.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  TimeScale,
  Tooltip,
  Legend
);

export const SessionPopBody = ({ services, session, pagginationState, setPagginationState, user, machine, row, historiesData }: {
  services: Services
  session: CurrentSession
  pagginationState: StaticPaginatedTableState
  setPagginationState: Dispatch<SetStateAction<StaticPaginatedTableState>>
  user?: User | undefined,
  machine?: Machine | undefined,
  row: SessionStat
  historiesData: UserDeviceHistoriesData
  onClose: () => void
}) => {
  const navigate = useNavigate()
  const translates = session.translates
  const [selectedMachine, setSelectedMachine] = useState<UserDeviceHistoriesMachine>()
  const [navData, setNavData] = useState<HitMapNavData>({
    range: {
      from: row.startAt ? new Date(row.startAt) : new Date(),
      to: row.endAt ? new Date(row.endAt) : new Date()
    },
    hitLvl: 'all',
    machinePoint: row.machineId,
    username: '',
    hitRange: hitsMap.all
  })


  const { rows, error } = useHitMap(services, `/api/communal/machines/byid/${row.machineId}/hits/map?${HitMapNavURLParams(navData)}`)

  const selectedHistoriesData = useMemo<UserDeviceHistoriesData>(() => ({
    hash: Date.now().toString(),
    histories: {
      [row.id]: historiesData.histories[row.id]
    },
    machines: {
      [row.imei]: historiesData.machines[row.imei]
    },
    users: historiesData.users
  }), [row, historiesData])

  if (row === undefined) {
    return <div className='spinner'></div>
  }

  // const buckets = row.buckets//row.buckets.filter((item) => item.active);
  // const labels = buckets.map(d => d.bucket);

  // const chartData = {
  //   labels,
  //   datasets: [
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_hit_count'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.countHits })),
  //       borderColor: "rgba(54, 162, 235, 0.8)",
  //       backgroundColor: "rgba(54, 162, 235, 0.1)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_max_hit_x'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.maxHitX })),
  //       borderColor: "rgba(255, 206, 86, 0.8)",
  //       backgroundColor: "rgba(255, 206, 86, 0.1)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_max_hit_y'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.maxHitY })),
  //       borderColor: "rgba(75, 192, 192, 0.8)",
  //       backgroundColor: "rgba(75, 192, 192, 0.1)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_max_speed'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.maxSpeed })),
  //       borderColor: "rgba(255, 99, 71, 0.8)",
  //       backgroundColor: "rgba(255, 99, 71, 0.1)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },

  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_avr_hit_x'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.avgHitX })),
  //       borderColor: "rgba(253, 219, 133, 0.8)",
  //       backgroundColor: "rgba(255, 206, 86, 0.1)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_avr_hit_y'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.avgHitY })),
  //       borderColor: "rgba(126, 189, 189, 0.8)",
  //       backgroundColor: "rgba(75, 192, 192, 0.1)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },
  //     // {
  //     //   label: translates.for('page.statistics.sessiondetailspop.chart_avr_speed'),
  //     //   data: buckets.map(d => ({ x: d.bucket, y: d.maxSpeed })),
  //     //   borderColor: "rgba(255, 183, 171, 0.8)",
  //     //   backgroundColor: "rgba(255, 99, 71, 0.1)",
  //     //   tension: 0.4,
  //     //   yAxisID: "main",
  //     // },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_min_soc'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.minSOC })),
  //       borderColor: "rgba(57, 40, 255, 0.8)",
  //       backgroundColor: "rgba(255, 99, 71, 0.1)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_min_ubat'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.minUbat })),
  //       borderColor: "rgba(251, 40, 255, 0.8)",
  //       backgroundColor: "rgba(222, 64, 236, 0.5)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_max_current'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.maxCurrent })),
  //       borderColor: "rgba(255, 234, 40, 0.8)",
  //       backgroundColor: "rgba(165, 135, 0, 0.5)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //     },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_max_mth'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.maxEngineHours })),
  //       borderColor: "rgba(0, 28, 155, 0.8)",
  //       backgroundColor: "rgba(0, 28, 155, 0.5)",
  //       tension: 0.4,
  //       yAxisID: "main",
  //       hidden: true,
  //     },
      
  //     // {
  //     //   label: translates.for('page.statistics.sessiondetailspop.chart_max_hit_z'),
  //     //   data: buckets.map(d => ({ x: d.bucket, y: d.maxHitZ })),
  //     //   borderColor: "rgba(153, 102, 255, 0.8)",
  //     //   backgroundColor: "rgba(153, 102, 255, 0.1)",
  //     //   tension: 0.4,
  //     //   yAxisID: "main",
  //     // },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_fire'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.onFire ? 1 : 0 })),
  //       borderColor: "rgba(255, 99, 132, 0.8)",
  //       backgroundColor: "rgba(255, 99, 132, 0.1)",
  //       borderDash: [8, 4],
  //       tension: 0,
  //       yAxisID: "flags",
  //     },
  //     {
  //       label: translates.for('page.statistics.sessiondetailspop.chart_active'),
  //       data: buckets.map(d => ({ x: d.bucket, y: d.onFire ? 1 : 0 })),
  //       borderColor: "rgba(166, 127, 9, 0.78)",
  //       backgroundColor: "rgba(252, 255, 99, 0.1)",
  //       borderDash: [8, 4],
  //       tension: 0,
  //       yAxisID: "flags",
  //     }
  //   ],
  // };

  // const options: ChartOptions<"line"> = {
  //   responsive: true,
  //   plugins: {
  //     legend: { display: true },
  //     tooltip: {
  //       mode: "index",
  //       intersect: false
  //     },
  //     title: {
  //       display: true,
  //       text: translates.for('page.statistics.sessiondetailspop.title'),
  //     },
  //   },
  //   scales: {
  //     x: {
  //       type: "time",
  //       time: {
  //         unit: "minute",
  //         tooltipFormat: "yyyy-MM-dd HH:mm",
  //         displayFormats: { minute: "yyyy-MM-dd HH:mm" }
  //       },
  //       title: { display: true, text: "Frame Time" }
  //     },
  //     main: {
  //       type: "linear",
  //       position: "left",
  //       title: { display: true, text: translates.for('page.statistics.sessiondetailspop.chart_values_label') }
  //     },
  //     flags: {
  //       type: "linear",
  //       position: "right",
  //       min: -0.1,
  //       max: 1.1,
  //       grid: { drawOnChartArea: false },
  //       ticks: {
  //         callback: (v) => v === 1 ? translates.for('bool.true') : v === 0 ? translates.for('bool.false') : "",  // Show bool meaning
  //       },
  //       title: { display: true, text: translates.for('page.statistics.sessiondetailspop.chart_flags_label') }
  //     },
  //   },
  // };

  const maxHit = Math.max(Number(row.maxHitX), Number(row.maxHitY), Number(row.maxHitZ))

  return <div className='communal-statistics-session-pop'>
    <h3>{row.startAt ? formatDate(new Date(row.startAt)) : ''} - {row.endAt ? formatDate(new Date(row.endAt)) : '...'}</h3>
    {user ? <h4 className='sub-title'>{user.username}</h4> : null}
    {machine ? <h4 className='sub-title'>{[
      row.manufacturer,
      row.category ? translates.for(`machine.types.${row.category}`) : null,
      row.model,
      row.internalNumber,
    ].filter(val => val != null && val !== '').join(' > ')}
    </h4> : null}

    <div className="session-details-table">
      <div className="hcol">{translates.for('elements.table.sessions.start_at')}</div>
      <div className="col">{row.startAt ? formatDate(new Date(row.startAt)) : '-'}</div>

      <div className="hcol">{translates.for('elements.table.sessions.end_at')}</div>
      <div className="col">{row.endAt ? formatDate(new Date(row.endAt)) : '-'}</div>

      <div className="hcol">{translates.for('elements.table.sessions.active_time')}</div>
      <div className="col"><TimeDHM dhm={secondsToDHM(row.activeTime)} translates={translates} /></div>

      <div className="hcol">{translates.for('elements.table.sessions.on_fire_time')}</div>
      <div className="col"><TimeDHM dhm={secondsToDHM(row.onFireTime)} translates={translates} /></div>

      <div className="hcol">{translates.for('elements.table.sessions.total_hits')}</div>
      <div className="col">{row.totalHits ? row.totalHits : '0'}</div>

      <div className="hcol">{translates.for('elements.table.sessions.max_hit')}</div>
      <div className="col"><HitText value={maxHit}>{maxHit.toFixed(2)}</HitText></div>

      <div className="hcol">{translates.for('elements.table.sessions.max_x')}</div>
      <div className="col"><HitText value={Number(row.maxHitX)}>{Number(row.maxHitX).toFixed(2)}</HitText></div>

      <div className="hcol">{translates.for('elements.table.sessions.max_y')}</div>
      <div className="col"><HitText value={Number(row.maxHitY)}>{Number(row.maxHitY).toFixed(2)}</HitText></div>

      {row.maxHitZ ? <>
        <div className="hcol">{translates.for('elements.table.sessions.max_z')}</div>
        <div className="col"><HitText value={Number(row.maxHitZ)}>{Number(row.maxHitZ).toFixed(2)}</HitText></div>
      </> : null}

      <div className="hcol">{translates.for('elements.table.sessions.max_speed')}</div>
      <div className="col">{row.maxSpeed ? Number(row.maxSpeed).toFixed(2) + "km/h" : '-'}</div>

      <div className="hcol">{translates.for('elements.table.sessions.ucid')}</div>
      <div className="col">{row.ucid}</div>

      <div className="hcol">{translates.for('elements.table.sessions.username')}</div>
      <div className="col" onClick={() => navigate(`/communal/statistics/users?user=${row.userId}`)}>{row.username || row.userId}</div>

      <div className="hcol">{translates.for('elements.table.sessions.machine_npath')}</div>
      <div className="col" onClick={() => navigate(`/communal/statistics/machines?machine=${row.machineId}`)}>
        {[
          row.manufacturer,
          row.category ? translates.for(`machine.types.${row.category}`) : null,
          row.model,
          row.internalNumber,
        ].filter(val => val != null && val !== '').join(' > ')}
      </div>
    </div>
    <div style={{ width: '100%' }}>
      <MachineHistoryChart buckets={row.buckets} />
    </div>
    <CommunalUserPathMap services={services} session={session} historiesData={selectedHistoriesData} selectedMachine={selectedMachine} setSelectedMachine={setSelectedMachine} />

    <HitMapNav session={session} services={services} data={navData} setter={setNavData} fieldMatrix={{
      range: false,
      username: false,
      machineName: false
    }} />

    <div className='hit-map-box'>
      <HitMapComponent error={error} rows={rows} services={services} session={session} />
    </div>
  </div>
}

